/**
 * PostLikes 骨架屏组件
 *
 * CLS 优化：为点赞列表区域提供布局稳定的骨架屏
 *
 * 问题：切换帖子时，点赞数据加载过程中只显示 Spin，容器高度变化导致 CLS
 *
 * 解决：在 initialLoading 时显示与 PostLikes 布局一致的骨架屏，保持容器高度稳定
 */
import { Skeleton } from 'antd';

interface PostLikesSkeletonProps {
  /** 是否显示移动端预览模式（简化版） */
  isMobilePreview?: boolean;
  /** 显示的骨架项数量 */
  itemCount?: number;
}

export default function PostLikesSkeleton({ isMobilePreview = false, itemCount = 6 }: PostLikesSkeletonProps) {
  return (
    <div className="w-full flex flex-col h-full">
      {/* 标题和搜索框骨架 */}
      <div className="p-4 max-md:p-0 max-md:pb-2">
        <div className="flex flex-col gap-2">
          {/* 标题：{totalLikes} Likes */}
          <Skeleton.Input active style={{ width: 80, height: 24 }} />

          {!isMobilePreview && (
            <>
              {/* 副标题：Last X likes */}
              <Skeleton.Input active style={{ width: 180, height: 16 }} />

              {/* 搜索框 */}
              <div className="mt-2">
                <Skeleton.Input active style={{ width: '100%', height: 36, borderRadius: 8 }} />
              </div>
            </>
          )}
        </div>
      </div>

      {/* 点赞列表骨架 */}
      <div className="flex-1 overflow-hidden">
        {Array.from({ length: itemCount }, (_, index) => (
          <div key={index} className="p-4 max-md:p-2.5">
            <div className="flex items-center gap-3">
              {/* 序号圆形 */}
              <Skeleton.Avatar active size={20} />

              {/* 用户头像 */}
              <Skeleton.Avatar active size={40} />

              {/* 用户信息 */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-col gap-1">
                  {/* 用户名 */}
                  <Skeleton.Input active style={{ width: 120, height: 16 }} />
                  {/* @username */}
                  <Skeleton.Input active style={{ width: 100, height: 14 }} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
